import React from 'react';
import { Outlet } from 'react-router-dom';
import TravelerSubNavigation from '../../components/traveler-sub-navigation';

const View = () => (
  <>
    <TravelerSubNavigation />
    <Outlet />
  </>
);

export default View;
